var map = {
	"./celebrate_emoji.svg": "./frontend_shared/components/base-components/icon-svg/celebrate_emoji.svg",
	"./change-team.svg": "./frontend_shared/components/base-components/icon-svg/change-team.svg",
	"./check-dark.svg": "./frontend_shared/components/base-components/icon-svg/check-dark.svg",
	"./check.svg": "./frontend_shared/components/base-components/icon-svg/check.svg",
	"./drag-hand.svg": "./frontend_shared/components/base-components/icon-svg/drag-hand.svg",
	"./edit.svg": "./frontend_shared/components/base-components/icon-svg/edit.svg",
	"./editwhite.svg": "./frontend_shared/components/base-components/icon-svg/editwhite.svg",
	"./filter.svg": "./frontend_shared/components/base-components/icon-svg/filter.svg",
	"./logo-white-v-blue-circle.svg": "./frontend_shared/components/base-components/icon-svg/logo-white-v-blue-circle.svg",
	"./mentions-empty-image.svg": "./frontend_shared/components/base-components/icon-svg/mentions-empty-image.svg",
	"./mentions-empty.svg": "./frontend_shared/components/base-components/icon-svg/mentions-empty.svg",
	"./note.svg": "./frontend_shared/components/base-components/icon-svg/note.svg",
	"./pending-analysis.svg": "./frontend_shared/components/base-components/icon-svg/pending-analysis.svg",
	"./refresh-ccw.svg": "./frontend_shared/components/base-components/icon-svg/refresh-ccw.svg",
	"./x.svg": "./frontend_shared/components/base-components/icon-svg/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./frontend_shared/components/base-components/icon-svg sync recursive ^\\.\\/.*\\.svg$";